module.exports = __webpack_public_path__ + "static/media/zl_2_15.2caca1e7.png";